<template>
  <div class="select-wrap">
    <el-tooltip placement="top" content="フィード投稿">
    <div class="select-item" @click="changeMediaType('feed')" :class="media_type == 'feed' ? 'active' : ''">
      <font-awesome-icon :icon="['far', 'table-cells']" style="font-size:14px"/>
    </div>
    </el-tooltip>
    <el-tooltip placement="top" content="リール投稿">
    <div class="select-item" @click="changeMediaType('reel')" :class="media_type == 'reel' ? 'active' : ''">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="height:60%;" fill="currentColor" >
        <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="currentColor"/>
      </svg>      
    </div>
    </el-tooltip>
    <el-tooltip v-if="has_stories" placement="top" content="ストーリーズ投稿">
    <div class="select-item" @mouseover="mouseover = true" @mouseleave="mouseover = false" @click="changeMediaType('stories')" :class="media_type == 'stories' ? 'active' : ''">
      <img :src="require('../../../assets/stories_'+color+'.png')" alt="" style="height:60%">
    </div>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "selectButton",
  props: ["media_type", "has_stories"],
  data() {
    return {
      mouseover: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    color(){
      if (this.mouseover||this.media_type=="stories") {
        return 'blue';
      } else {
        return 'grey';
      }
    }
  },
  mounted(){

  },
  methods: {
    changeMediaType(media_type){
      this.$emit("update:media_type", media_type)
    }
  },
  watch:{
  }
};
</script>

<style></style>
